<div *ngIf="cargando">
  <div class="text-center py-5">
      <mat-spinner class="img-center"></mat-spinner>
  </div>
  <div class="text-center py-5">
    <span>Cargando datos...</span>
  </div>
</div>

<div *ngIf="!cargando && !datosRF.datos">
  <div class="mt-3 opacity-75">
    <h3 class="mb-0">{{ mostrarNombreCompleto() }} no tiene reconocimiento facial registrado.</h3>
  </div>
</div>

<div class="overflow-hidden pb-3" *ngIf="!cargando && datosRF.datos">
  <div class="d-flex justify-content-end" *ngIf="esModoVerificaIncidencia">
    <button class="ace-button-danger" (click)="volverIncidencias()">Volver a incidencias</button>
  </div>
  <canvas id="face-marks" style="position: absolute; z-index: 1"></canvas>
  <div class="cam-wrapper mt-3" *ngIf="(!mostrarFotoTomada || verificacionContinua) && !esModoVerificaIncidencia">
    <webcam [width]="camaraAncho" [height]="camaraAlto" [allowCameraSwitch]="true" [videoOptions]="videoOptions" [trigger]="invokeObservable" [switchCamera]="nextWebcamObservable"
    (imageCapture)="captureImg($event)"></webcam>
  </div>
  <div class="cam-wrapper mt-3" *ngIf="mostrarFotoTomada">
    <h4 class="m-0 fw-semibold">Foto Tomada</h4>
    <img [src]="fotoTomada" alt="Foto de la Cámara" class="img-fluid" style="height: 10rem;">
  </div>
  <div *ngIf="infoCamara" class="mb-2">
    <span [class.text-muted]="!aplicarEstilos" [class.text-danger]="aplicarEstilos">{{ infoCamara }}</span>
    <span class="text-danger" *ngIf="similitudEmpleadoActual && verificacionContinua"> {{ similitudEmpleadoActual }}</span>
  </div>
  <div *ngIf="datosEmpleado && !mostrarDatosError" class="my-2">
    <span>{{ datosEmpleado }}</span>
  </div>
  <div *ngIf="datosEmpleado && mostrarDatosError" class="my-2">
    <div class="fw-semibold">{{ datosEmpleado }}</div>
    <div class="text-danger fw-medium">{{ empleadoActual }}<span class="fw-semibold me-2">{{ similitudEmpleadoActual }}</span></div>
  </div>

  <button mat-raised-button class="text-primary me-2" (click)="iniciarTomaAutomatica()" *ngIf="!verificacionContinua && !esModoVerificaIncidencia">{{ mostrarFotoTomada ? 'Verificar nuevamente' : 'Verificar foto' }}</button>
  <button mat-raised-button class="text-primary me-2" (click)="verificaContinua()" *ngIf="!verificacionContinua && !esModoVerificaIncidencia">Verificación continua</button>
  <button mat-raised-button class="text-primary me-2" (click)="detenerVerificaContinua()" *ngIf="verificacionContinua">Detener verificación continua</button>
  <button *ngIf="fotoTomadaGuardar && !verificacionContinua" mat-raised-button class="text-success" (click)="guardarFoto(fotoTomadaGuardar)">Asignar como foto de registro facial para {{ nombreCompleto(empleado) }}</button>

  <div class="row row-cols-1 row-cols-md-3 row-cols-lg-4 g-3 mx-auto my-3">
    <div *ngFor="let comparacion of comparaciones">
      <div class="centro ace-card">
        <img [src]="comparacion.fotoRegistrada" alt="Foto Registrada" class="img-fluid my-1" style="height: 10rem;">
        <div class="text-center pb-2" style="font-size: 14px;">
          <p class="m-0"><b>Similitud: </b> {{ comparacion.similitud }}</p>
          <p class="mb-0 mx-2 col-11 text-truncate" [matTooltip]="comparacion.nombrePunto"><b>Registrado en: </b> {{ comparacion.nombrePunto }}</p>
          <button class="ace-button-danger mt-1" (click)="abrirModal(eliminar, comparacion.idFotoRegistrada, comparacion.fotoRegistrada)">Eliminar foto</button>
        </div>
      </div>
    </div>
  </div>

  <div class="input-group mt-5" *ngIf="esModoVerificaIncidencia">
    <label class="mb-0 input-group-text" style="border: unset;">Comparar contra otro empleado</label>
    <ng-select class="col-3 text-start" [disabled]="cargando" [items]="empleados" [(ngModel)]="empleadoSeleccionado" (ngModelChange)="verificarEmpleadoSeleccionado()" bindLabel="nombreCompleto" (clear)="limpiarFiltro()" notFoundText="Empleado no encontrado" placeholder="Seleccionar empleado" appendTo="body" dropdownPosition="auto">
      <ng-template ng-option-tmp let-item="item">
        {{ nombreCompleto(item) }}
      </ng-template>
    </ng-select>
  </div>
</div>

<ng-template #eliminar>
  <div class="d-flex justify-content-between align-items-center px-3 border-bottom border-light shadow-sm mb-3">
    <h2 class="mb-0 ms-2 fw-bold">Eliminar foto registrada</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="modalRef?.hide()"></button>
  </div>

  <div class="modal-body">
    <p class="fs-5 text-center">¿Estás seguro de que deseas eliminar esta foto registrada?
      <br>
      Esta acción no se puede deshacer.
    </p>

    <div class="text-center mb-2">
      <img [src]="fotoSeleccionada" alt="Foto Seleccionada" class="img-fluid" style="height: 10rem;">
    </div>

    <div class="d-flex justify-content-end">
      <button class="text-secondary mx-2" mat-raised-button [disabled]="cargando" (click)="modalRef?.hide()">Cancelar</button>

      <button class="ace-button-danger" [disabled]="cargando" (click)="eliminarImagen(idFotoSeleccionada)">
        Eliminar foto
      </button>
    </div>
  </div>
</ng-template>
